import type { RouteRecordRaw } from 'vue-router';
import { vouchersRoutesDictionary } from './vouchers-routes.dictionary.ts';

export const vouchersRoutesConfig: RouteRecordRaw = {
  ...vouchersRoutesDictionary.vouchers.root,
  redirect: { name: vouchersRoutesDictionary.vouchers.list.name },
  children: [
    {
      ...vouchersRoutesDictionary.vouchers.list,
      component: () => import('../pages/List/VouchersListPage.vue'),
    },
    {
      ...vouchersRoutesDictionary.vouchers.detail,
      component: () => import('../pages/Detail/VoucherDetailPage.vue'),
      props: true,
    },
  ],
};
